<template>
    <section class="text-primary-white px-3 sm:px-3 lg:my-16 sm:my-10 background overflow-x-hidden">
        <div class="pb-[100px]">
            <div class="flex flex-col">
                <div class="w-full px-4 pr-12 justify-center text-center">
                    <div class="mb-12 lg:mb-0 wow fadeInUp" data-wow-delay=".15s"
                        style="visibility: visible; animation-delay: 0.15s">
                        <!-- Semantically an h2 (heading order), sized to match the previous h5 visual weight via explicit classes rather than the tag's default size. -->
                        <h2 class="font-medium mb-11 text-base sm:text-lg lg:text-xl xl:text-2xl">
                            {{ title || 'Integrate them all with a unified API and/or unified MCP' }}
                        </h2>
                        <h6 v-if="subtitle && !subtitle_link" class="text-neutral-50 text-sm">
                            {{ subtitle }}
                        </h6>
                        <h6 v-if="subtitle_link" class="text-neutral-50 text-sm mt-0">
                            <a :href="subtitle_link" class=" btn btn-secondary mt-0">
                                {{ subtitle }}
                                <Icon name="ic:round-keyboard-arrow-right" />
                            </a>
                        </h6>
                    </div>
                </div>

                <div class="flex px-4 sm:px-12 justify-center mt-12 content-center">
                    <div class="text-center wow fadeInUp container-fluid" data-wow-delay=".2s"
                        style="visibility: visible; animation-delay: 0.2s">
                        <div
                            class="carousel-slider-left overflow-hidden h-52 w-1/6 object-contain z-10 left-0 absolute" />
                        <div
                            class="carousel-slider-right overflow-hidden h-52 w-1/6 object-contain z-10 right-0 absolute" />
                        <div class="wrapper flex flex-col">
                            <div class="row_1 h-[102px] relative mt-2">
                                <div v-for="row in ROWS" :class="[(row % 2) === 0 ? 'first' : 'second']"
                                    class="flex items-center justify-center">

                                    <div v-for="index in COLS" class="integration-box">
                                        <a v-if="INTEGRATIONS[randomIntegrations[index + 0 * COLS]]"
                                            :href="`/integrations/${INTEGRATIONS[randomIntegrations[index + 0 * COLS]].type}`">
                                            <img :src="INTEGRATIONS[randomIntegrations[index + 0 * COLS]].logo_url || '/images/integration-fallback.svg'" @error="onLogoError"
                                                class="integration-logo"
                                                :title="INTEGRATIONS[randomIntegrations[index + 0 * COLS]].name"
                                                :alt="INTEGRATIONS[randomIntegrations[index + 0 * COLS]].name" />
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div class="row_2 h-[102px] relative">
                                <div v-for="row in ROWS" :class="[(row % 2) === 0 ? 'third' : 'fourth']"
                                    class="flex items-center justify-center">

                                    <div v-for="index in COLS" class="integration-box">
                                        <a v-if="INTEGRATIONS[randomIntegrations[index + 1 * COLS]]"
                                            :href="`/integrations/${INTEGRATIONS[randomIntegrations[index + 1 * COLS]].type}`">
                                            <img :src="INTEGRATIONS[randomIntegrations[index + 1 * COLS]].logo_url || '/images/integration-fallback.svg'" @error="onLogoError"
                                                class="integration-logo"
                                                :title="INTEGRATIONS[randomIntegrations[index + 1 * COLS]].name"
                                                :alt="INTEGRATIONS[randomIntegrations[index + 1 * COLS]].name" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { onLogoError } from '~/composables/useLogoFallback';
import type { TIntegrationCategory } from '~/models/Unified';
import { CATS, INTEGRATIONS } from '../services/integrations';
import { MAP_CATS } from '~~/services/categories';

const ROWS = 2;
const COLS = 16;

export default {
    props: {
        title: String,
        subtitle: String,
        subtitle_link: String,
        category: String,
    },
    data() {
        return {
            CATS,
            ROWS,
            COLS,
            MAP_CATS,
            INTEGRATIONS: this.category ? INTEGRATIONS.filter(i => i.categories?.includes(this.category as TIntegrationCategory)) : INTEGRATIONS,
            randomIntegrations: [] as number[],
            timerID: undefined as any | undefined,
            currentSlot: 0,
        };
    },
    methods: {
        onLogoError,
        randomizeSlots() {
            for (let i = 0; i < INTEGRATIONS.length; i++) {
                this.randomIntegrations[i] = i;
            }

            for (let i = 0; i < ROWS * COLS; i++) {
                const t1 = this.getRandomVendor();
                const t2 = this.getRandomVendor();

                const t = this.randomIntegrations[t1];
                this.randomIntegrations[t1] = this.randomIntegrations[t2];
                this.randomIntegrations[t2] = t;
            }
            this.randomIntegrations = this.randomIntegrations.slice(0, (ROWS + 1) * (COLS + 1));
        },
        fillSlots() {
            const slot = Math.floor(Math.random() * ROWS * COLS);

            const t = this.getRandomVendor();
            if (!this.randomIntegrations.includes(t)) {
                this.randomIntegrations[slot] = t;
            } else {
                // setTimeout(this.fillSlots, 2000);
                // console.log('redo');
            }
        },
        fillSlotsSequence() {
            const t = this.getRandomVendor();
            this.randomIntegrations[this.currentSlot] = t;
            this.currentSlot = (this.currentSlot + 1) % (ROWS * COLS);
            // setTimeout(this.fillSlots, 2000);
        },

        getRandomVendor() {
            let rndVendor = Math.floor(Math.random() * INTEGRATIONS.length);

            // console.log('randon', rndVendor);
            return rndVendor;
        },
    },
    mounted() {
        this.randomizeSlots();
        // this.timerID = setInterval(this.fillSlotsSequence, 30000);
    },
    unmounted() {
        clearTimeout(this.timerID);
        this.timerID = undefined;
    },
};
</script>

<style scoped>
.carousel-slider-left {
    background: linear-gradient(to right, var(--background) 0%, var(--background) 50%, rgba(0, 0, 0, 0) 100%);
}

.carousel-slider-right {
    background: linear-gradient(to left, var(--background) 0%, var(--background) 50%, rgba(0, 0, 0, 0) 100%);
}

.wrapper {
    width: calc(var(--slide-width) * 16);
    position: relative;
    /* background-color: rgba(0, 255, 0, 0.5);*/
}

/*
 * The four rows below scroll via `transform: translateX()` (composited, GPU-driven)
 * instead of animating `left`/`right` (triggers layout on every frame). Each row's
 * `left`/`right` stays fixed as its static base position; the keyframes only move it
 * with a transform offset from that base, so the on-screen motion is unchanged.
 */
.first {
    /* background-color: rgba(255, 0, 0, 0.5); */
    width: calc(var(--slide-width) * 16);
    position: absolute;
    left: 0px;
    top: 0;
    animation: firstDiv 60s linear infinite;

}

@keyframes firstDiv {
    0% {
        transform: translateX(0);
    }

    49.9% {
        transform: translateX(calc(var(--slide-width) * -16));
        opacity: 1;
    }

    49.99% {
        opacity: 0;
    }

    50% {
        transform: translateX(calc(var(--slide-width) * 16));
        opacity: 1;
    }


    100% {
        transform: translateX(0);
    }
}

.second {
    width: calc(var(--slide-width) * 16);
    /* background-color: rgba(0, 0, 255, 0.5); */
    position: absolute;
    left: calc(var(--slide-width) * 16);
    top: 0;
    animation: secondDiv 60s linear infinite;
}

@keyframes secondDiv {
    0% {
        transform: translateX(0);
    }

    50% {
        transform: translateX(calc(var(--slide-width) * -16));
    }

    99.9% {
        transform: translateX(calc(var(--slide-width) * -32));
        opacity: 1;
    }

    99.99% {
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.third {
    /* background-color: rgba(255, 0, 0, 0.5); */
    width: calc(var(--slide-width) * 16);
    position: absolute;
    right: 0px;
    top: 0;
    animation: thirdDiv 60s linear infinite;

}

@keyframes thirdDiv {
    0% {
        transform: translateX(0);
    }

    49.9% {
        transform: translateX(calc(var(--slide-width) * 16));
        opacity: 1;
    }

    49.99% {
        opacity: 0;
    }

    50% {
        transform: translateX(calc(var(--slide-width) * -16));
        opacity: 1;
    }


    100% {
        transform: translateX(0);
    }
}

.fourth {
    width: calc(var(--slide-width) * 16);
    /* background-color: rgba(0, 0, 255, 0.5); */
    position: absolute;
    right: calc(var(--slide-width) * 16);
    top: 0;
    animation: fourthDiv 60s linear infinite;
}

@keyframes fourthDiv {
    0% {
        transform: translateX(0);
    }

    50% {
        transform: translateX(calc(var(--slide-width) * 16));
    }

    99.9% {
        transform: translateX(calc(var(--slide-width) * 32));
        opacity: 1;
    }

    99.99% {
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/*
@keyframes carousel {
    0% {
        transform: translateX(0%);
    }

    100% {
        transform: translateX(-50%);
    }
}

.animate-carousel {
    animation: carousel 20s linear infinite;
}

*/
</style>